import { render, staticRenderFns } from "./DialogFormatText.vue?vue&type=template&id=7cf09b2c&scoped=true"
import script from "./DialogFormatText.vue?vue&type=script&lang=js"
export * from "./DialogFormatText.vue?vue&type=script&lang=js"
import style0 from "./DialogFormatText.vue?vue&type=style&index=0&id=7cf09b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf09b2c",
  null
  
)

export default component.exports